export default __webpack_public_path__ + "static/trade-gothic-ltstd-bdcn20-3537f6103f53b6001f88aeaaf11aa0f1.woff";